// extracted by mini-css-extract-plugin
module.exports = {"title":"title-blok_title__cpgVK","extra__wide":"title-blok_extra__wide__05BsM"};